import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Arrow from '../assets/images/icons/down-arrow-icon.svg'

const administrationFee = {
  personalLoan: 'Administration fee up to 9.99%.',
  securedPersonalLoan: 'Administration fee of 2.5%. State lien fees range from $4 – $95.'
}

class RateTermsV3 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      states: [],
      stateSelected: {
        disclaimers: []
      },
      isHovered: false
    }
  }

  componentDidMount() {
    this.orderData(this.props.data)
  }

  orderData = data => {
    const statesObj = data
    const stateArr = []

    Object.keys(statesObj).forEach(keys => stateArr.push(Object.assign(statesObj[keys])))

    const stateData = stateArr.reduce((acc, { state_name, products, active }) => {
      const { loan_amount_range, apr_range, loan_term_range, disclaimers } = products[0]

      return [
        ...acc,
        {
          name: state_name,
          active,
          loanAmount: `$${loan_amount_range[0].toLocaleString()}-$${loan_amount_range[1].toLocaleString()}`,
          loanTermRange: `${loan_term_range[0]}-${loan_term_range[1]} months`,
          aprRange: `${(apr_range[0] * 100).toFixed(2)}%-${(apr_range[1] * 100).toFixed(2)}%`,
          disclaimers
        }
      ]
    }, [])

    // alphabetize states by state name
    stateData.sort((a, b) => (a.name > b.name ? 1 : -1))

    const stateSelected = stateData[0]

    this.setState({ states: stateData, stateSelected })
  }

  handleSelectedState = name => {
    const stateSelected = this.state.states.filter(state => name === state.name)[0]

    this.setState({ stateSelected, isHovered: false })
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true })
  }

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
  }

  render() {
    const {
      states,
      stateSelected: { name: stateName, loanAmount, aprRange, loanTermRange, disclaimers, active },
      isHovered
    } = this.state

    const { changeLayout, type } = this.props

    return (
      <section className="rates-terms">
        <div className="container__inner">
          <div className="rates-terms__heading-box">
            <h5 className="datapoints">
              <>
                <span className="rates-terms--heading-top">Rates and terms</span>
                <br />
                for the state of&nbsp;
              </>

              {changeLayout ? null : <br />}
              <div
                className="rates-terms__state"
                onClick={this.handleMouseEnter}
                onKeyPress={this.handleMouseEnter}
                role="tree"
                tabIndex={0}
              >
                {stateName}
                <img src={Arrow} alt="dropdown arrow" className="rates-terms__dropdown-arrow" />

                <div
                  className={`rates-terms__dropdown ${
                    isHovered ? 'rates-terms__dropdown--show' : null
                  }`}
                  onMouseLeave={this.handleMouseLeave}
                >
                  <p className="rates-terms__dropdown-header">Select one...</p>
                  <div className="rates-terms__list-box">
                    <ul className="rates-terms__list">
                      {states.map(({ name }) => (
                        <li
                          className="rates-terms__item rates-terms__text"
                          key={name}
                          onClick={e => {
                            this.handleSelectedState(e.target.innerHTML)
                            e.stopPropagation()
                          }}
                          onKeyPress={e => {
                            this.handleSelectedState(e.target.innerHTML)
                            e.stopPropagation()
                          }}
                          role="presentation"
                        >
                          {name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </h5>
          </div>
          {!active ? (
            <div className="rates-terms__covid-alert-content-box">
              <div className="rates-terms__covid-alert">
                <p>
                  Applications for residents in the state of {this.state.stateSelected.name} are not
                  currently accepted.
                </p>
              </div>
            </div>
          ) : (
            <div className="rates-terms__content-box">
              <div className="rates-terms__text-box">
                <h5 className="datapoints-sub">loan amount ranges</h5>
                <p className="datapoints--terms">
                  {loanAmount}
                  <sup>*</sup>
                </p>
              </div>
              <div className="rates-terms__text-box">
                <h5 className="datapoints-sub">loan term ranges</h5>
                <p className="datapoints--terms">
                  {loanTermRange}
                  <sup>**</sup>
                </p>
              </div>
              <div className="rates-terms__text-box">
                <h5 className="datapoints-sub">apr ranges</h5>
                <p className="datapoints--terms">
                  {aprRange}
                  <sup>*</sup>
                </p>
              </div>
            </div>
          )}
          <div className="rates-terms__disclaimer-box">
            {disclaimers.map(text => (
              <p className="rates-terms__disclaimer" key={`${text} ${new Date().getTime()}`}>
                {text}
              </p>
            ))}
            <p className="rates-terms__disclaimer">{administrationFee[type]}</p>
          </div>
        </div>
      </section>
    )
  }
}

RateTermsV3.defaultProps = {
  changeLayout: false
}

RateTermsV3.propTypes = {
  changeLayout: PropTypes.bool,
  type: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
}

export default RateTermsV3
